<script>
import LayoutBase from "./LayoutBase.vue";

export default {
  name: "LayoutEnvelope",
  props: {
    contentStyle: {
      type: String,
      default: ""
    },
    noPaddingMobile: {
      type: Boolean,
      default: false
    },
    background: {
      type: String,
      default: "bg-white"
    }
  },
  components: {
    LayoutBase
  },
  computed: {
    contentClass() {
      let contentClass =
        "lg:mt-4 lg:p-12 lg:pb-0 lg:w-7/10 lg:min-h-0 lg:rounded-t-xl lg:overflow-y-hidden overflow-x-hidden w-full flex-grow self-center flex flex-col overflow-y-auto h-full";

      if (!this.noPaddingMobile) {
        contentClass += " pt-6 px-3";
      }

      contentClass += ` ${this.background}`;

      return contentClass;
    }
  }
};
</script>

<template>
  <LayoutBase
    :paddingTop="false"
    :paddingLeft="false"
    :paddingRight="false"
    :paddingBottom="false"
  >
    <div :class="contentClass" :style="contentStyle">
      <div class="flex flex-grow flex-col h-full">
        <slot></slot>
      </div>
    </div>
  </LayoutBase>
</template>
